<script setup lang="ts">
import { defineAsyncComponent, ref } from 'vue';
import dynamicWidgets from './WidgetImports';

const $props = defineProps<{
  name: string;
  widget: any;
}>();

const asyncComponent = ref(null);

if (Object.keys(dynamicWidgets).includes($props.name)) {
  asyncComponent.value = defineAsyncComponent(dynamicWidgets[$props.name]);
}
</script>

<template>
  <component :is="asyncComponent" :name="name" :widget="widget"></component>
</template>

<style scoped></style>
